// import Printable from "components/modules/reporting/A4";
// import React, { useRef, useState } from "react";
// import { Button, Card, Col, Form, Row } from "react-bootstrap";
// import { useLocation, useNavigate } from "react-router-dom";
// import logo from "../../../../assets/img/logos/logoNew.png";
// import { formatDate } from "date-fns";

// export default function ProfitAndLossReport() {
//   const navigate = useNavigate();
//   const { state } = useLocation();
//   const printRef = useRef();

//   const triggerPrint = () => {
//     printRef.current?.handlePrint?.();
//   };

//   const formatAmount = (amount) =>
//     amount?.toLocaleString(undefined, { minimumFractionDigits: 2 });

//   const dummyState = {
//     operatingRevenue: [
//       { id: 1, name: "Product Sales", amount: 50000 },
//       { id: 2, name: "Service Revenue", amount: 15000 },
//     ],
//     totalOperatingRevenue: 65000,
//     otherRevenue: [{ id: 3, name: "Interest Income", amount: 2000 }],
//     totalOtherRevenue: 2000,
//     totalRevenue: 67000,
//     costOfGoodsSold: [{ id: 4, name: "Raw Materials", amount: 25000 }],
//     totalCOGS: 25000,
//     operatingExpenses: [
//       { id: 5, name: "Salaries", amount: 15000 },
//       { id: 6, name: "Rent", amount: 5000 },
//     ],
//     totalOperatingExpenses: 20000,
//     otherExpenses: [{ id: 7, name: "Depreciation", amount: 3000 }],
//     totalOtherExpenses: 3000,
//     totalExpenses: 48000,
//     grossProfit: 42000,
//     operatingProfit: 22000,
//     netProfit: 19000,
//   };

//   const data = state || dummyState;

//   return (
//     <Card>
//       <Card.Header className="border-bottom">
//         <Row className="flex-between-center">
//           <Col md>
//             <div className="d-flex align-items-center">
//               <h5 className="fs-9 text-nowrap mb-2 mb-md-0">
//                 Reports | Profit and Loss
//               </h5>

//               <div className="d-flex align-items-center gap-2 mx-4">
//                 <Form.Select
//                   aria-label="Default Currency"
//                   type="text"
//                   title="Default Currency"
//                   className="py-2 mb-1"
//                 >
//                   <option value="">Fiscal Year</option>
//                   <option value="2023">2023-2024</option>
//                   <option value="2024">2024-2025</option>
//                   <option value="2025">2025-2026</option>
//                 </Form.Select>
//               </div>
//             </div>
//           </Col>
//           <Col xs="auto">
//             <Button
//               variant="link"
//               className="text-secondary fw-medium p-0 me-3"
//               onClick={() => navigate(-1)}
//             >
//               Cancel
//             </Button>
//             <Button variant="primary" onClick={triggerPrint}>
//               Print
//             </Button>
//           </Col>
//         </Row>
//       </Card.Header>

//       <Printable ref={printRef} documentTitle="Profit and Loss Report">
//         <div
//           style={{
//             padding: 40,
//             fontFamily: "Arial, sans-serif",
//           }}
//         >
//           {/* Header */}
//           <div className="d-flex justify-content-between">
//             <div>
//               <div style={{ textAlign: "center", color: "black" }}>
//                 <img
//                   height={80}
//                   width={80}
//                   src={logo}
//                   alt="Logo"
//                   style={{ marginBottom: "20px" }}
//                 />
//               </div>
//               <h4 style={{ textAlign: "center", color: "black" }}>
//                 Profit & Loss
//               </h4>
//             </div>
//             <div></div>
//           </div>

//           {/* Reference and Company */}
//           <div className="d-flex justify-content-between my-4">
//             <div>
//               <strong>Company Name:</strong> ABC Corporation
//               <br />
//               <strong>Address:</strong> 123 Main St, City, Country
//             </div>
//             <div className="text-end">
//               <div>
//                 <strong>Fiscal Year:</strong> 2023 - 2024
//               </div>
//               <div>
//                 <strong>Printed:</strong> {new Date().toLocaleDateString()}
//               </div>
//             </div>
//           </div>

//           {/* === REVENUE SECTION === */}
//           <Section title="REVENUE">
//             <Subsection
//               title="Operating Revenue"
//               items={data.operatingRevenue}
//               total={data.totalOperatingRevenue}
//             />
//             <Subsection
//               title="Other Revenue"
//               items={data.otherRevenue}
//               total={data.totalOtherRevenue}
//             />
//             <TotalLine label="TOTAL REVENUE" amount={data.totalRevenue} />
//           </Section>

//           {/* === EXPENSES SECTION === */}
//           <Section title="EXPENSES">
//             <Subsection
//               title="Cost of Goods Sold"
//               items={data.costOfGoodsSold}
//               total={data.totalCOGS}
//             />
//             <Subsection
//               title="Operating Expenses"
//               items={data.operatingExpenses}
//               total={data.totalOperatingExpenses}
//             />
//             <Subsection
//               title="Other Expenses"
//               items={data.otherExpenses}
//               total={data.totalOtherExpenses}
//             />
//             <TotalLine label="TOTAL EXPENSES" amount={data.totalExpenses} />
//           </Section>

//           {/* === PROFIT SECTION === */}
//           <Section title="PROFIT SUMMARY">
//             <TotalLine label="GROSS PROFIT" amount={data.grossProfit} />
//             <TotalLine label="OPERATING PROFIT" amount={data.operatingProfit} />
//             <TotalLine
//               label={`NET ${data.netProfit >= 0 ? "PROFIT" : "LOSS"}`}
//               amount={Math.abs(data.netProfit)}
//             />
//           </Section>

//           {/* === APPROVAL SIGNATURE === */}
//           <div className="d-flex justify-content-between mt-5">
//             <div>APPROVED BY:</div>
//             <div
//               style={{ borderBottom: "1px solid #000", width: "250px" }}
//             ></div>
//           </div>
//         </div>
//       </Printable>
//     </Card>
//   );

//   function Section({ title, children }) {
//     return (
//       <div style={{ marginTop: 40 }}>
//         <h5
//           style={{
//             border: "1px solid #000",
//             padding: 8,
//             backgroundColor: "#e6e6e6",
//             color: "#000",
//           }}
//         >
//           {title}
//         </h5>
//         {children}
//       </div>
//     );
//   }

//   function Subsection({ title, items, total }) {
//     return (
//       <div style={{ marginTop: 20, marginLeft: 10 }}>
//         <h6 style={{ fontWeight: "bold", marginBottom: 10 }}>{title}</h6>
//         <table style={{ width: "100%", borderCollapse: "collapse" }}>
//           <tbody>
//             {items?.map((item) => (
//               <tr key={item.id}>
//                 <td style={{ ...styles.td, paddingLeft: 30 }}>{item.name}</td>
//                 <td style={styles.tdP}>{formatAmount(item.amount)}</td>
//               </tr>
//             ))}
//             <tr>
//               <td style={{ ...styles.tdFT, paddingLeft: 30 }}>Total {title}</td>
//               <td style={styles.tdF}>{formatAmount(total)}</td>
//             </tr>
//           </tbody>
//         </table>
//       </div>
//     );
//   }

//   function TotalLine({ label, amount }) {
//     return (
//       <table
//         style={{
//           width: "100%",
//           borderCollapse: "collapse",
//           marginTop: 15,
//           backgroundColor: "#e6e6e6",
//         }}
//       >
//         <tbody>
//           <tr>
//             <td style={{ ...styles.tdFT, paddingLeft: 20 }}>{label}</td>
//             <td style={styles.tdF}>{formatAmount(amount)}</td>
//           </tr>
//         </tbody>
//       </table>
//     );
//   }
// }

// const styles = {
//   printBtn: {
//     padding: "5px 10px",
//     backgroundColor: "#4CAF50",
//     color: "white",
//     border: "none",
//     borderRadius: "2px",
//     cursor: "pointer",
//     marginRight: "40px",
//   },
//   th: {
//     border: "1px solid #000",
//     padding: "8px",
//     textAlign: "left",
//     backgroundColor: "#e6e6e6",
//     fontWeight: "bold",
//   },
//   td: {
//     border: "1px solid #000",
//     padding: "8px",
//     textAlign: "left",
//   },
//   tdP: {
//     border: "1px solid #000",
//     padding: "8px",
//     textAlign: "right",
//   },
//   tdFT: {
//     fontWeight: "bold",
//     border: "1px solid #000",
//     padding: "8px",
//     textAlign: "left",
//     backgroundColor: "#e6e6e6",
//   },
//   tdF: {
//     fontWeight: "bold",
//     border: "1px solid #000",
//     padding: "8px",
//     textAlign: "right",
//     backgroundColor: "#e6e6e6",
//   },
// };
import Printable from "components/modules/reporting/A4";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Button, Card, Col, Collapse, Form, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../../../../assets/img/logos/logoNew.png";
import { useSettingContext } from "context/SettingContext";
import { useFetchFinanceBook } from "hooks/useFetchFinanceBook";
import { IoIosArrowDropdown, IoIosArrowDropup } from "react-icons/io";
import PageTitle from "utils/PageTitle";

export default function ProfitAndLossReport() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const printRef = useRef();
  const headerRef = useRef();
  const collapseButtonRef = useRef();
  const [reportData, setReportData] = useState(null);
  const triggerPrint = () => {
    printRef.current?.handlePrint?.();
  };

  const formatAmount = (amount) =>
    amount?.toLocaleString(undefined, { minimumFractionDigits: 2 });

  const dummyState = {
    operatingRevenue: [
      { id: 1, name: "Product Sales", amount: 50000 },
      { id: 2, name: "Service Revenue", amount: 15000 },
    ],
    totalOperatingRevenue: 65000,
    otherRevenue: [{ id: 3, name: "Interest Income", amount: 2000 }],
    totalOtherRevenue: 2000,
    totalRevenue: 67000,
    costOfGoodsSold: [{ id: 4, name: "Raw Materials", amount: 25000 }],
    totalCOGS: 25000,
    operatingExpenses: [
      { id: 5, name: "Salaries", amount: 15000 },
      { id: 6, name: "Rent", amount: 5000 },
    ],
    totalOperatingExpenses: 20000,
    otherExpenses: [{ id: 7, name: "Depreciation", amount: 3000 }],
    totalOtherExpenses: 3000,
    totalExpenses: 48000,
    netProfit: 19000,
  };

  const data = state || dummyState;

  const settingsData = useSettingContext();
  const costCenter = useMemo(
    () => settingsData?.find((d) => d.name === "DEFAULT_COST_CENTER"),
    [settingsData]
  );
  const costCenterId = Number(costCenter?.value) || 1; // Ensure it's a number

  const { data: financeBooksData, isLoading: financeBookLoading } =
    useFetchFinanceBook(costCenterId);

  const [collapseIn, setCollapseIn] = useState(false);
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);

  const toggleFilters = () => setCollapseIn(!collapseIn);

  useEffect(() => {
    const handleScroll = () => {
      if (headerRef.current) {
        const rect = headerRef.current.getBoundingClientRect();
        setIsHeaderVisible(rect.bottom > 0);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <PageTitle name="Reports | Profit & Loss" />
      <Card>
        {/* <Card.Header className="border-bottom">
        <Row className="flex-between-center">
          <Col md>
            <div className="d-flex align-items-center">
              <h5
                className="fs-9 text-nowrap mb-2 mb-md-0"
                style={{ width: "19.5rem" }}
              >
                Reports | Profit and Loss
              </h5>
              <div className="d-flex align-items-center gap-2">
                <Form.Select
                  aria-label="Fiscal Year"
                  className="fs-9"
                  style={{ width: "200px" }}
                >
                  <option value="">Finance Book</option>
                  {financeBooksData?.data.data.map((d) => (
                    <option key={d.id} value={d.id}>
                      {d.name}
                    </option>
                  ))}
                </Form.Select>
                <Form.Select aria-label="Fiscal Year" className="">
                  <option value="">Fiscal Year</option>
                  <option value="2023">2023-2024</option>
                  <option value="2024">2024-2025</option>
                </Form.Select>
              </div>
            </div>
          </Col>
          <Col xs="auto">
            <Button
              variant="link"
              className="text-secondary fw-medium p-0 me-3"
              onClick={() => navigate(-1)}
            >
              Cancel
            </Button>
            <Button variant="primary" onClick={triggerPrint}>
              Print
            </Button>
          </Col>
        </Row>
      </Card.Header> */}

        <Card.Header
          ref={headerRef}
          className="border-bottom sticky-header"
          style={{
            position: "sticky",
            top: -90,
            backgroundColor: "white",
            zIndex: 1000,
            paddingBottom: collapseIn ? "1rem" : "1.5rem",
            transition: "padding-bottom 0.3s ease",
          }}
        >
          <div className="header-content">
            <Row className="flex-between-center align-items-center">
              <Col md>
                <div className="d-flex align-items-center flex-wrap gap-2">
                  <h5
                    className="fs-9 text-nowrap mb-2 mb-md-0"
                    style={{ width: "19.5rem" }}
                  >
                    Reports | Profit & Loss
                  </h5>
                </div>
              </Col>
              <Col xs="auto">
                <Button
                  variant="link"
                  className="text-secondary fw-medium p-0 me-3"
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </Button>
                {reportData ? (
                  <>
                    <Button variant="primary" onClick={triggerPrint}>
                      Print
                    </Button>
                  </>
                ) : (
                  <>
                    <Button variant="primary">Preview</Button>
                  </>
                )}
              </Col>
            </Row>

            <Collapse in={collapseIn}>
              <div className="filter-row">
                <Row className="mt-3">
                  <Col
                    md="auto"
                    style={{
                      marginLeft: "20rem",
                      display: "flex",
                      gap: 10,
                    }}
                  >
                    <Form.Select
                      aria-label="Fiscal Year"
                      className="fs-9"
                      style={{ width: "180px" }}
                    >
                      <option value="">Finance Book</option>
                      {financeBooksData?.data.data.map((d) => (
                        <option key={d.id} value={d.id}>
                          {d.name}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Select aria-label="Fiscal Year" className="">
                      <option value="">Fiscal Year</option>
                      <option value="2023">2023-2024</option>
                      <option value="2024">2024-2025</option>
                    </Form.Select>
                  </Col>
                </Row>
              </div>
            </Collapse>
          </div>

          {/* Collapse toggle button fixed to border-bottom */}
          <div
            ref={collapseButtonRef}
            style={{
              position: "absolute",
              right: "7.5rem",
              bottom: "-15px",
              zIndex: 1001,
              backgroundColor: "white",
              borderRadius: "50%",
              boxShadow: "0 0 0 2px white",
              visibility: isHeaderVisible ? "visible" : "hidden",
              transition: "visibility 0.2s ease",
            }}
          >
            {collapseIn ? (
              <IoIosArrowDropup
                title="Hide Filters"
                size={30}
                onClick={toggleFilters}
                className="cursor-pointer"
              />
            ) : (
              <IoIosArrowDropdown
                title="Show Filters"
                size={30}
                onClick={toggleFilters}
                className="cursor-pointer"
              />
            )}
          </div>
        </Card.Header>

        <Printable ref={printRef} documentTitle="Profit and Loss Report">
          {reportData && (
            <div style={{ padding: 40, fontSize: "14px" }}>
              {/* Header */}
              <div className="d-flex justify-content-between">
                <div>
                  <div style={{ textAlign: "center", color: "black" }}>
                    <img
                      height={80}
                      width={80}
                      src={logo}
                      alt="Logo"
                      style={{ marginBottom: "20px" }}
                    />
                  </div>
                  <h4 style={{ textAlign: "center", color: "black" }}>
                    Profit & Loss
                  </h4>
                </div>
                <div></div>
              </div>

              {/* Reference and Company */}
              <div className="d-flex justify-content-between my-4">
                <div>
                  <strong>Company Name:</strong> ABC Corporation
                  <br />
                  <strong>Address:</strong> 123 Main St, City, Country
                </div>
                <div className="text-end">
                  <div>
                    <strong>Fiscal Year:</strong> 2023-2024
                  </div>
                  <div>
                    <strong>Printed:</strong> {new Date().toLocaleDateString()}
                  </div>
                </div>
              </div>

              {/* Revenue Section */}
              <div style={{ marginTop: 30 }}>
                <table style={styles.table}>
                  <thead>
                    <tr>
                      <th colSpan={2} style={styles.toPth}>
                        REVENUE
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td
                        colSpan="2"
                        style={{ ...styles.tdGroup, paddingLeft: "18px" }}
                      >
                        <span style={{ fontSize: 14 }}>Operating Revenue</span>
                      </td>
                    </tr>
                    {data.operatingRevenue.map((item) => (
                      <tr key={item.id}>
                        <td style={{ ...styles.td, paddingLeft: "30px" }}>
                          {item.name}
                        </td>
                        <td style={styles.tdP}>{formatAmount(item.amount)}</td>
                      </tr>
                    ))}
                    <tr>
                      <td style={{ ...styles.tdSubtotal, paddingLeft: "30px" }}>
                        Total Operating Revenue
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(data.totalOperatingRevenue)}
                      </td>
                    </tr>

                    <tr>
                      <td
                        colSpan="2"
                        style={{ ...styles.tdGroup, paddingLeft: "18px" }}
                      >
                        <span style={{ fontSize: 14 }}>Other Revenue</span>
                      </td>
                    </tr>

                    {data.otherRevenue.map((item) => (
                      <tr key={item.id}>
                        <td style={{ ...styles.td, paddingLeft: "30px" }}>
                          {item.name}
                        </td>
                        <td style={styles.tdP}>{formatAmount(item.amount)}</td>
                      </tr>
                    ))}
                    <tr>
                      <td style={{ ...styles.tdSubtotal, paddingLeft: "30px" }}>
                        Total Other Revenue
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(data.totalOtherRevenue)}
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td style={{ ...styles.tdTotal, paddingLeft: "10px" }}>
                        <span>TOTAL REVENUE</span>
                      </td>
                      <td style={styles.tdTotalP}>
                        <strong>{formatAmount(data.totalRevenue)}</strong>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              {/* Expenses Section */}
              <div style={{ marginTop: 30 }}>
                <table style={styles.table}>
                  <thead>
                    <tr>
                      <th colSpan={2} style={styles.toPth}>
                        EXPENSES
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td
                        colSpan="2"
                        style={{ ...styles.tdGroup, paddingLeft: "18px" }}
                      >
                        <span style={{ fontSize: 14 }}>Cost of Goods Sold</span>
                      </td>
                    </tr>
                    {data.costOfGoodsSold.map((item) => (
                      <tr key={item.id}>
                        <td style={{ ...styles.td, paddingLeft: "30px" }}>
                          {item.name}
                        </td>
                        <td style={styles.tdP}>{formatAmount(item.amount)}</td>
                      </tr>
                    ))}
                    <tr>
                      <td style={{ ...styles.tdSubtotal, paddingLeft: "30px" }}>
                        Total COGS
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(data.totalCOGS)}
                      </td>
                    </tr>

                    <tr>
                      <td
                        colSpan="2"
                        style={{ ...styles.tdGroup, paddingLeft: "18px" }}
                      >
                        <span style={{ fontSize: 14 }}>Operating Expenses</span>
                      </td>
                    </tr>
                    {data.operatingExpenses.map((item) => (
                      <tr key={item.id}>
                        <td style={{ ...styles.td, paddingLeft: "30px" }}>
                          {item.name}
                        </td>
                        <td style={styles.tdP}>{formatAmount(item.amount)}</td>
                      </tr>
                    ))}
                    <tr>
                      <td style={{ ...styles.tdSubtotal, paddingLeft: "30px" }}>
                        Total Operating Expenses
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(data.totalOperatingExpenses)}
                      </td>
                    </tr>

                    <tr>
                      <td
                        colSpan="2"
                        style={{ ...styles.tdGroup, paddingLeft: "18px" }}
                      >
                        <strong style={{ fontSize: 14 }}>Other Expenses</strong>
                      </td>
                    </tr>
                    {data.otherExpenses.map((item) => (
                      <tr key={item.id}>
                        <td style={{ ...styles.td, paddingLeft: "30px" }}>
                          {item.name}
                        </td>
                        <td style={styles.tdP}>{formatAmount(item.amount)}</td>
                      </tr>
                    ))}
                    <tr>
                      <td style={{ ...styles.tdSubtotal, paddingLeft: "30px" }}>
                        Total Other Expenses
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(data.totalOtherExpenses)}
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td style={{ ...styles.tdTotal, paddingLeft: "10px" }}>
                        <strong>TOTAL EXPENSES</strong>
                      </td>
                      <td style={styles.tdTotalP}>
                        <strong>{formatAmount(data.totalExpenses)}</strong>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              {/* Net Profit Display */}
              <div style={{ marginTop: 30 }}>
                <table style={styles.table}>
                  <tbody>
                    <tr>
                      <td
                        colSpan={3}
                        style={{ ...styles.tdNetProfit, paddingLeft: "10px" }}
                      >
                        <strong>
                          NET {data.netProfit >= 0 ? "PROFIT" : "LOSS"}
                        </strong>
                      </td>
                      <td style={styles.tdNetProfitP}>
                        <strong>
                          {formatAmount(Math.abs(data.netProfit))}
                        </strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Approval Signature */}
              <div
                style={{
                  marginTop: 100,
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <div style={{ width: 300, textAlign: "center" }}>
                  <div
                    style={{ borderBottom: "1px solid #000", marginBottom: 9 }}
                  ></div>
                  <div>Authorized Signature</div>
                </div>
              </div>
            </div>
          )}
        </Printable>
      </Card>
    </>
  );
}
const border = "1px solid #000";
const basePadding = "8px 10px";
const baseTextAlignLeft = "left";
const baseTextAlignRight = "right";

const bg = {
  lightGray: "#f8f8f8",
  gray: "#e6e6e6",
  darkGray: "#A9A9A9",
};

const styles = {
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: 20,
  },
  toPth: {
    backgroundColor: bg.darkGray,
    border,
    padding: basePadding,
    textAlign: baseTextAlignLeft,
    fontWeight: "bold",
  },
  td: {
    border,
    borderRight: "none",
    padding: basePadding,
    textAlign: baseTextAlignLeft,
  },
  tdP: {
    border,
    borderLeft: "none",
    padding: basePadding,
    textAlign: baseTextAlignRight,
  },
  tdGroup: {
    border,
    padding: basePadding,
    textAlign: baseTextAlignLeft,
    backgroundColor: bg.gray,
    fontWeight: "bold",
  },
  tdSubtotal: {
    border,
    borderRight: "none",
    padding: basePadding,
    textAlign: baseTextAlignLeft,
    fontWeight: "bold",
    backgroundColor: bg.lightGray,
  },
  tdSubtotalP: {
    border,
    borderLeft: "none",
    padding: basePadding,
    textAlign: baseTextAlignRight,
    fontWeight: "bold",
    backgroundColor: bg.lightGray,
  },
  tdTotal: {
    border,
    borderRight: "none",
    padding: basePadding,
    textAlign: baseTextAlignLeft,
    fontWeight: "bold",
    backgroundColor: bg.darkGray,
  },
  tdTotalP: {
    border,
    borderLeft: "none",
    padding: basePadding,
    textAlign: baseTextAlignRight,
    fontWeight: "bold",
    backgroundColor: bg.darkGray,
  },
  tdNetProfit: {
    border,
    borderRight: "none",
    padding: "8px 10px",
    textAlign: baseTextAlignLeft,
    fontWeight: "bold",
    fontSize: "1.1em",
    backgroundColor: bg.darkGray,
  },
  tdNetProfitP: {
    border,
    borderLeft: "none",
    padding: "8px 10px",
    textAlign: baseTextAlignRight,
    fontWeight: "bold",
    fontSize: "1.1em",
    backgroundColor: bg.darkGray,
  },
};
